import platformPackage from "../../package.json";

export const platformVersion = platformPackage.version;
export const platformVersionLabel = `Version ${platformVersion}`;
